export const version = `v2.2.30 06/18/26 11:02pm`;